import { Stack } from "@mantine/core"
import { useDisclosure } from "@mantine/hooks"
import { CountryIso3166 } from "@tfg/db"
import { useEffect, useState } from "react"

import { HeaderControlsProvider } from "~/components/contexts/useHeaderControlsContext"
import { Suppliers } from "~/pages/Brand/Suppliers/SuppliersRepository/Suppliers"
import { SupplierCreationModal } from "~/pages/Brand/Suppliers/SuppliersRepository/components/SupplierCreationModal"
import useSupplierMappingForm from "~/pages/Brand/Suppliers/SuppliersRepository/utils/useSupplierMappingForm"
import { ContactDrawer } from "~/pages/SupplierPortal/TraceabilityRequests/components/ContactDrawer"

export const SUPPLIER_INITIAL_VALUES = {
  id: "",
  supplierId: "",
  name: "",
  email: "",
  organization: {
    name: "",
    street: "",
    city: "",
    postalCode: "",
    country: CountryIso3166.FR,
    registrationId: [],
    businessRelationship: {
      id: "",
      isActive: true,
      supplierCode: "",
      type: null,
    },
  },
}

export const SuppliersSettings = () => {
  const [searchSupplier, setSearchSupplier] = useState<string>("")
  const [isDrawerOpen, drawerActions] = useDisclosure(false)
  const [isCreationModalOpen, creationModalActions] = useDisclosure(false)
  const [valuesUpdated, setValuesUpdated] = useState(false)
  const { supplierMapping, setSupplierMapping, handleSupplierMapping } =
    useSupplierMappingForm({})

  const openAddSupplierModal = () => {
    creationModalActions.open()
  }

  const openAddSupplierDrawer = () => {
    setValuesUpdated(true)
  }

  const isUpdate =
    "supplierId" in supplierMapping && supplierMapping.supplierId !== ""

  useEffect(() => {
    if (valuesUpdated) {
      drawerActions.open()
      setValuesUpdated(false)
    }
  }, [valuesUpdated, drawerActions, setValuesUpdated])

  return (
    <HeaderControlsProvider>
      <Stack gap="md">
        <Suppliers
          setInitialValues={setSupplierMapping}
          setFormType={() => undefined}
          setValuesUpdated={setValuesUpdated}
          searchSupplier={searchSupplier}
          setSearchSupplier={setSearchSupplier}
          openAddSupplierModal={openAddSupplierModal}
        />

        <SupplierCreationModal
          opened={isCreationModalOpen}
          onClose={creationModalActions.close}
          openDrawer={openAddSupplierDrawer}
          setInitialValues={setSupplierMapping}
          searchSupplier={searchSupplier}
        />
        <ContactDrawer
          opened={isDrawerOpen}
          setModalOpened={drawerActions}
          supplierMapping={supplierMapping}
          handleSupplierMapping={handleSupplierMapping}
          isUpdate={isUpdate}
        />
      </Stack>
    </HeaderControlsProvider>
  )
}
